import {
  ACTIVE_CHAT_UPDATE,
  CHAT_MESSAGE,
  LOST_MESSAGE,
  CHAT_RESET,
  CHAT_SET,
  INDIVIDUAL_CHAT_RESET,
  INITIAL_CHAT_SET,
  LOGOUT,
  RESET_UNREAD_MESSAGE_COUNT,
  UPDATE_CHAT_TRANSCRIPT,
  SET_TRANSFER_END_POINTS_UPDATE,
  SET_SELECTED_ATTACHMENT_UPDATE,
  SET_UPLOADING_ATTACHMENT_UPDATE,
  STORE_LOGIN,
  RESET_STATE,
  HISTORY_FILTER_CHAT_COUNT,
  UNSEND_CHAT_MESSAGE,
} from "../constants/action-types";
import { SHOW_SELECTED_ATTACHMENT } from "../constants/constants";
import { CHAT_UNREAD_MSG_SIDEBAR } from "../constants/events";
import Emitter from "../emitter";
import { IndividualChat } from "../types/chat.type";
import { mergeUnique } from "../utils";

const initialState: any = { chats: [], activeChatID: "", chatCount: 0 };
export default (state = initialState, action: any) => {
  switch (action.type) {
    case CHAT_SET: {
      let chatId = action.chat.id;

      let existingIndex = state.chats.findIndex(
        (chat: IndividualChat) => chatId === chat.id
      );
      let chats = [...state.chats];
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          ...action.chat,
        };
      } else {
        chats.unshift(action.chat);
      }
      return {
        ...state,
        chats,
      };
    }
    case INITIAL_CHAT_SET: {
      return {
        ...state,
        ...action.chat,
      };
    }

    case CHAT_MESSAGE: {
      let chatId = action.message.webChatConversation.id;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex(
        (chat: IndividualChat) => chatId === chat.id
      );
      if (existingIndex > -1) {
        Emitter.emit(CHAT_UNREAD_MSG_SIDEBAR, true);
        const unreadMsgCnt =
          state.activeChatID !== chatId
            ? (chats[existingIndex].unreadMessages ?? 0) + 1
            : 0;
        chats[existingIndex] = {
          ...chats[existingIndex],
          messages: [...(chats[existingIndex].messages || []), action.message],
          unreadMessages: unreadMsgCnt,
          scrollUpdate: false,
        };
      }
      return {
        ...state,
        chats: chats,
      };
    }

    case LOST_MESSAGE: {
      const chats = [...state.chats];
      if (action.message.length > 0) {
        const chatId = action.message[0].webChatConversation.id;
        let existingIndex = chats.findIndex((chat) => chatId === chat.id);
        if (existingIndex > -1) {
          const unreadMsgCnt =
            state.activeChatID !== chatId
              ? (chats[existingIndex].unreadMessages ?? 0) + 1
              : 0;
          chats[existingIndex] = {
            ...chats[existingIndex],
            messages: [...action.message],
            unreadMessages: unreadMsgCnt,
          };
        }
        return {
          ...state,
          chats: chats,
        };
      } else {
        return {
          ...state,
          chats: chats,
        };
      }
    }
    case RESET_UNREAD_MESSAGE_COUNT: {
      let chatId = action.chatID;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex((chat) => chatId === chat.id);
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          unreadMessages: 0,
        };
      }
      return {
        ...state,
        chats: chats,
      };
    }
    case ACTIVE_CHAT_UPDATE: {
      const chatId = action.chatID;
      return {
        ...state,
        activeChatID: chatId,
      };
    }
    case SET_SELECTED_ATTACHMENT_UPDATE: {
      let chatId = action.message.conversationId;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex((chat) => chatId === chat.id);
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          attachment: action.message.attachment,
        };
      }
      return {
        ...state,
        chats: chats,
      };
    }

    case SHOW_SELECTED_ATTACHMENT: {
      const chatId = action.payload.conversationId;
      const i = state.chats.findIndex((chat: any) => chatId == chat.id);

      const chats = [...state.chats];
      chats[i] = {
        ...chats[i],
        attachment: action.payload.attachment,
      };

      return {
        ...state,
        chats,
      };
    }

    case UPDATE_CHAT_TRANSCRIPT: {
      let chatId = action.message.conversationId;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex((chat) => chatId === chat.id);
      let updatedTranscript = [];
      if (chats[existingIndex]?.transcript) {
        updatedTranscript = mergeUnique(
          action.message.transcript,
          chats[existingIndex].transcript,
          "messageId"
        );
      } else {
        updatedTranscript = action.message.transcript;
      }
      console.log(
        "+++++++++++++IN UI REDUCER++++++++++++++",
        updatedTranscript,
        action.message.nextHistoryToken
      );
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          transcript: updatedTranscript,
          nextHistoryToken: action.message.nextHistoryToken,
          scrollUpdate: true,
        };
      }

      return {
        ...state,
        chats: chats,
      };
    }

    case SET_TRANSFER_END_POINTS_UPDATE: {
      let chatId = action.message.conversationId;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex((chat) => chatId === chat.id);
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          allowedTransferEndpoints: [
            ...action.message.allowedTransferEndpoints,
          ],
        };
      }
      return {
        ...state,
        chats,
      };
    }
    case LOGOUT:
    case CHAT_RESET:
      return { chats: [], activeChatID: "" };
    case INDIVIDUAL_CHAT_RESET: {
      let chatId = action.chat.id;
      let chatCopy = [...state.chats];
      let chats = chatCopy.filter((currentValue) => currentValue.id !== chatId);
      return {
        ...state,
        chats,
      };
    }

    case SET_UPLOADING_ATTACHMENT_UPDATE: {
      let chatId = action.message.conversationId;
      let chats = [...state.chats];
      let existingIndex = chats.findIndex((chat) => chatId === chat.id);
      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          uploadingFiles: [...action.message.attachment],
        };
      }
      return {
        ...state,
        chats,
      };
    }
    case STORE_LOGIN:
      return {
        ...state,
        ...action.payload.chat,
      };
    case UNSEND_CHAT_MESSAGE: {
      const { chatId, message } = action;
      const chats = [...state.chats];
      const existingIndex = chats.findIndex((chat) => chatId === chat.id);

      if (existingIndex > -1) {
        chats[existingIndex] = {
          ...chats[existingIndex],
          draftChatMsg: message,
        };
      }

      return {
        ...state,
        chats,
      };
    }

    case HISTORY_FILTER_CHAT_COUNT:
      return {
        ...state,
        chatCount: action.chatCount,
      };
    case RESET_STATE:
      return { chats: [], activeChatID: "" };
    default:
      return state;
  }
};
